<template>
  <!-- Total: 2+4+5+5+8+5+5+1+1 = 36 spans -->
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <BasicCell :span="2" />
    <BasicCell :span="4">
      <span>Référence</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dateEmission"
      />
      <span>Date de paiement</span>
    </BasicCell>
    <BasicCell :span="5">
      <span>Montant TTC</span>
    </BasicCell>
    <BasicCell :span="8">
      <span>Bénéficiaire</span>
    </BasicCell>
    <BasicCell :span="5">
      <span>Référence Facture</span>
    </BasicCell>
    <BasicCell :span="5">
      <span>Dossier</span>
    </BasicCell>
    <BasicCell :span="1" />
    <BasicCell :span="1" />
  </div>
</template>

<script setup lang="ts">
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue'

  const modelValue = defineModel<string>()
</script>
